import { Link } from 'react-router-dom';
import { admissionSteps } from '@/mocks/advancedCourseData';
import { useTranslation } from 'react-i18next';

const STEP_COUNT = 4;
const stepIndices = Array.from({ length: STEP_COUNT }, (_, i) => i);

export default function AdmissionFlow() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="text-center mb-14">
          {String(t('coursesAdvanced.admission.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-4">
            {t('coursesAdvanced.admission.title')}
          </h2>
          <div className="gold-line mx-auto"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {stepIndices.map((index) => {
            const step = admissionSteps[index];
            return (
              <div key={index} className="relative text-center group">
                {/* Step Number */}
                <div className="mb-5">
                  <span className="inline-flex items-center justify-center w-12 h-12 rounded-full border border-accent-500/30 bg-background-50 text-accent-600 font-heading text-sm tracking-[0.08em] group-hover:bg-accent-500 group-hover:text-primary-900 group-hover:border-accent-500 transition-all duration-400">
                    {step?.step}
                  </span>
                </div>

                {/* Connector Line */}
                {index < STEP_COUNT - 1 && (
                  <div className="hidden lg:block absolute top-6 left-[calc(50%+30px)] w-[calc(100%-60px)] h-[1px] bg-gradient-to-r from-accent-500/30 to-accent-500/10"></div>
                )}

                {/* Icon */}
                <span className="block w-9 h-9 mx-auto mb-3 flex items-center justify-center">
                  <i className={`${step?.icon} text-accent-600 text-lg group-hover:text-accent-500 transition-colors duration-300`}></i>
                </span>

                {/* Text */}
                <p className="text-[12px] text-accent-500/60 tracking-[0.12em] mb-2 font-label">
                  {t(`coursesAdvanced.admission.${index}.titleEn`).toUpperCase()}
                </p>
                <h4 className="font-heading text-[16px] text-foreground-900 tracking-[0.06em] mb-2">
                  {t(`coursesAdvanced.admission.${index}.title`)}
                </h4>
                <p className="text-[14px] text-foreground-600 leading-relaxed tracking-[0.03em]">
                  {t(`coursesAdvanced.admission.${index}.description`)}
                </p>

                {step?.href && step.href !== '#' && (
                  <Link
                    to={step.href}
                    className="inline-flex items-center gap-1 mt-3 text-[13px] text-accent-600 hover:text-accent-500 tracking-[0.06em] transition-colors duration-300"
                  >
                    <span>{t('coursesAdvanced.admission.viewDetail')}</span>
                    <i className="ri-arrow-right-line text-[12px]"></i>
                  </Link>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
